export const COMMIT_HASH = '81146bd1cadb2f32c287f1410de0eb9921cccb35';
